import { ColorTokens, FontFamilyTokens, FontSizeTokens, IconTokens, } from '@voltmoney/schema';
import React, { memo, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import Typography from '../typography/Typography';
import Radio from '../radio/Radio';
import ThemeProvider from "@voltmoney/theme";
const StepperHorizontalBase = ({ data }) => {
    const theme = ThemeProvider.getTheme();
    const [widthMap, setWidthMap] = useState({});
    const styles = StyleSheet.create({
        horizontalLine: {
            height: 1,
            backgroundColor: theme.colors[ColorTokens.Primary_100],
            //backgroundColor:ColorTokens.Grey_Chalk,
            flexGrow: 1,
            marginTop: 8,
            marginRight: 8,
        },
        horizontalLineGrey: {
            height: 1,
            backgroundColor: theme.colors[ColorTokens.Grey_Chalk],
            flexGrow: 1,
            marginTop: 8,
            marginRight: 8,
        },
    });
    function renderItems(item, index) {
        return (React.createElement(View, { key: `${item.order}-${index}`, style: !(index === data.length - 1)
                ? {
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    flexGrow: 1,
                }
                : {
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                } },
            React.createElement(View, { style: {
                    flexDirection: 'row',
                    marginLeft: 8,
                    width: '100%',
                    backgroundColor: theme.colors[ColorTokens.Transparent]
                } },
                React.createElement(Radio, { isChecked: item.status === 'COMPLETED', checkedIconName: IconTokens.CheckCircle, notCheckedIconName: item.status === 'IN_PROGRESS'
                        ? IconTokens.RadioCircleFilled
                        : IconTokens.EmptyCircle, isDisabled: true }),
                React.createElement(View, { style: { width: 8 } }),
                !(index === data.length - 1) && (React.createElement(View, { style: data[index]?.status === "COMPLETED" ? styles.horizontalLine : styles.horizontalLineGrey })),
                React.createElement(View, { style: { height: 8 } })),
            React.createElement(View, { style: {
                    marginLeft: -(item.horizontalDisplayName.length - 8),
                }, onLayout: (event) => {
                    if (!widthMap[index]) {
                        widthMap[index] =
                            event.nativeEvent.layout.width;
                        setWidthMap(widthMap);
                    }
                } },
                React.createElement(Typography, { label: item.horizontalDisplayName, numberOfLines: 2, color: item.status === 'COMPLETED'
                        ? ColorTokens.Primary_100
                        : item.status === 'IN_PROGRESS'
                            ? ColorTokens.Primary_100
                            : ColorTokens.Grey_Smoke, fontWeight: '600', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.XXS }))));
    }
    return (React.createElement(View, { style: {
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            paddingLeft: 16,
            paddingRight: 16,
        } }, data?.map(renderItems)));
};
export default memo(StepperHorizontalBase);
export { StepperHorizontalBase };
